/*
 * Bwè Manjé is a restaurant table booking application on the Android Platform.
 *
 * Copyright (C) 2020-2025 by Frédéric-Charles Barthéléry.
 *
 * This file is part of Bwè Manjé.
 */
package com.geekorum.rdv.bwemanje.showcase

import com.geekorum.rdv.bwemanje.accountdeletion.renderAccountDeletionPage
import firebase.app.initializeApp
import kotlinx.browser.document

private val FIREBASE_CONFIG = js("process.env.FIREBASE_CONFIG")

fun main() {
    val firebaseApp = initializeApp(FIREBASE_CONFIG)
    val root = document.getElementById("root")!!
    renderAccountDeletionPage(root, firebaseApp)
}